import { Typography, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { horizontalTabStyles } from '../../sharedStyles';

import React, { useState, useEffect } from 'react';

import { Link, useNavigate, useLocation } from "react-router-dom";

import { v2UIRoutePath } from '../../../../common/commons';

import { Tab, Tabs } from '../reconcilationreport/MuiStyled';

import RequestsReportGrid from './RequestsReportGrid';

import axios from '../../../../common/AxiosConfig';

import { AppContext } from '../../../../../RoutesWithAuth';

import { useContext } from 'react';


const useStyles = makeStyles(() => ({
    root: {
        '& .ashyperlink': {
            color: "#007bff",
            cursor: "pointer"
        }
    },
     appsScopeWrapper: {
        ...horizontalTabStyles.tabWrapper,
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    }

}));
const requestTabs = ["", "reviewrequests"];
const DuplicateRequestColumns = [{
    name: "#",
    mapping: "id",
    width: 40
}, {
    name: 'Request ID',
    mapping: "dsar_id",
    flex:1,
    width: 380,
    renderCell: (params) => {
        return (<span className='ashyperlink'>
            {params.row["dsar_id"]}
        </span>)
    }
}, {
    name: "Request Type",
    mapping: "ticket_type",
    width: 150
}, {
    name: "Requestor",
    mapping: "requestor",
    width: 120
}, {
    name: "Request Status",
    mapping: "status",
    width: 120
}, {
    name: "Created Date",
    mapping: "created_date",
    width: 200,
    renderCell: (params) => (
        <Tooltip title={params.row["createdDateandTimeLocal"]}>
            <span>
                {params.row["createdDateandTimeUTC"]}
            </span>
        </Tooltip>
    ),
}];
const ReviewRequestsColumns = [
    ...DuplicateRequestColumns.slice(0, 3),
    {
        name: "Workflow",
        mapping: "workflow",
        width: 170,
    },
    ...DuplicateRequestColumns.slice(3)
]
const ManualActionsRequestReport = ({ tabActiveParam }) => {
    const classes = useStyles();
    // State to handle the Main Tab Information
    const [activeTab, setActiveTab] = useState(0);
    const context = useContext(AppContext)
    const authToken = context.authToken.get

    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        // Activating the Tab based on the tab param in the route url
        let activeTabIndex = requestTabs.indexOf(tabActiveParam);
        // activating the first tab when the tab name does not match the list
        if (activeTabIndex < 0) {
            activeTabIndex = 0;
        }
        setActiveTab(activeTabIndex);
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[tabActiveParam])

    const passAndDisplayJSON = ({dsar_id}) => {
        navigate(v2UIRoutePath + "tracking/requestqueue/",
            {
                state: { passID: dsar_id }
            }
        )
    }

    return (
        <div className={classes.root}>
            <Typography variant="h6" className={'tabHeader'}>
                <Link color="primary" to={() => {
                    // Generating a Random Id and passing it as part of state 
                    // Every click on the Header will generate a unique Id
                    const autoId = Math.round(Math.random() * 1e5);
                    let subTab = "";
                    // Maintaining the active Tab State.
                    if (activeTab === 1) {
                        subTab = "reviewrequests"
                    }
                    return {
                        pathname: v2UIRoutePath + "reports/manualactionrequests/" + subTab,
                        state: { fromredirection: autoId }
                    }
                }}
                >
                    MANUAL ACTIONS REQUESTS
                </Link>
            </Typography>
            <Tabs
                variant="scrollable"
                aria-label="tabs"
                className={classes.appsScopeWrapper}
                value={activeTab}
                onChange={(_event, newValue) => {
                    setActiveTab(newValue);
                    // redirecting to the selected tab url so that refresh will retain in same page
                    navigate(`${v2UIRoutePath}reports/manualactionrequests/${requestTabs[newValue]}`)

                }}
                sx={{ borderRight: 1, borderColor: 'divider' }}
            >
                <Tab label="Duplicate Requests" />
                <Tab label="Review Requests" />
            </Tabs>
            {activeTab === 0 && (<RequestsReportGrid
                fromredirection={location?.state?.fromredirection}
                api={"/reports/duplicate-requests"}
                columns={DuplicateRequestColumns}
                downloadEnabled={false}
                onCellClick={(cellparams) => {
                    navigate(v2UIRoutePath + "requestdetails/" + cellparams.row.dsar_id);

                }}
            />)}

            {activeTab === 1 && (<RequestsReportGrid
                fromredirection={location?.state?.fromredirection}
                api={"/reports/review-report"}
                columns={ReviewRequestsColumns}
                downloadEnabled={false}
                onCellClick={(cellparams) => {
                    if(cellparams.row.workflow === "Response Consolidation"){
                        navigate(v2UIRoutePath + "requestdetails/" + cellparams.row.dsar_id);
                    } else {
                        passAndDisplayJSON(cellparams.row)
                    }
                }}
            />)}

        </div>
    )
};

export default React.memo(ManualActionsRequestReport);
